<app-header-style-one></app-header-style-one>
<router-outlet></router-outlet>
<app-footer></app-footer>